import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { DatosCompartidosService } from "./service/datos-compartidos.service";
import { Observable } from "rxjs";
import { Nexus } from "./util/nexus";
import { SolicitarServicioService } from "./service/solicitar-servicio.service";
import { environment } from "../environments/environment";

@Injectable()
export class UsuarioResolve implements Resolve<any> {

    constructor(
        private datosCompartidosService: DatosCompartidosService,
        private router: Router,
        private solicitarServicioService: SolicitarServicioService
    ) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<any> {
        
        let user: any = undefined;

        if(document.location.href.includes("admin")){
            user = JSON.parse(localStorage.getItem('activeUserWebAdmin'));
        }else if(document.location.href.includes("intranet")){
            user = JSON.parse(localStorage.getItem('activeUserIntranet'));
        }

        if (user != undefined) {
            Nexus.geolocate();
            Nexus.getCountryClient(this.solicitarServicioService);
            return this.datosCompartidosService.obtenerUsuario(user.IdCliente);


        } else {
            this.router.navigate(['']);
        }

    }

}
